
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AffidavitMetadataResponse,
  AffidavitSubmissionRequest,
  ValidationError,
} from '../models';
import {
    AffidavitMetadataResponseFromJSON,
    AffidavitMetadataResponseToJSON,
    AffidavitSubmissionRequestFromJSON,
    AffidavitSubmissionRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface GetAffidavitMetadataRequest {
    companyId: string;
}

export interface GetAffidavitPdfMetadataRequest {
    affidavitId: string;
}

export interface SubmitAffidavitRequest {
    affidavitSubmissionRequest: AffidavitSubmissionRequest;
}

/**
 * 
 */
export class AffidavitApi extends runtime.BaseAPI {

    /**
     * Get affidavit metadata for a freelancer company
          */
    async getAffidavitMetadataRaw(requestParameters: GetAffidavitMetadataRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AffidavitMetadataResponse>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getAffidavitMetadata().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AffidavitMetadataResponse>({
            path: `/compliance/api/affidavit/{companyId}/metadata`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AffidavitMetadataResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get affidavit metadata for a freelancer company
          */
    async getAffidavitMetadata(requestParameters: GetAffidavitMetadataRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AffidavitMetadataResponse> {
        const response = await this.getAffidavitMetadataRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get affidavit metadata for a specific submitted affidavit (used when rendering the PDF)
          */
    async getAffidavitPdfMetadataRaw(requestParameters: GetAffidavitPdfMetadataRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AffidavitMetadataResponse>> {
        if (requestParameters['affidavitId'] == null) {
            throw new runtime.RequiredError(
                'affidavitId',
                'Required parameter "affidavitId" was null or undefined when calling getAffidavitPdfMetadata().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AffidavitMetadataResponse>({
            path: `/compliance/api/affidavit/{affidavitId}/pdf-metadata`.replace(`{${"affidavitId"}}`, encodeURIComponent(String(requestParameters['affidavitId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AffidavitMetadataResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get affidavit metadata for a specific submitted affidavit (used when rendering the PDF)
          */
    async getAffidavitPdfMetadata(requestParameters: GetAffidavitPdfMetadataRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AffidavitMetadataResponse> {
        const response = await this.getAffidavitPdfMetadataRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Submit an affidavit for a freelancer company in place of an internal compliance document
          */
    async submitAffidavitRaw(requestParameters: SubmitAffidavitRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['affidavitSubmissionRequest'] == null) {
            throw new runtime.RequiredError(
                'affidavitSubmissionRequest',
                'Required parameter "affidavitSubmissionRequest" was null or undefined when calling submitAffidavit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/affidavit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AffidavitSubmissionRequestToJSON(requestParameters['affidavitSubmissionRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Submit an affidavit for a freelancer company in place of an internal compliance document
          */
    async submitAffidavit(requestParameters: SubmitAffidavitRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.submitAffidavitRaw(requestParameters, initOverrides);
    }

}
